up.viewport.config.fixedTop.push('.navigation')

up.network.config.progressBar = false
